import { Divider, Typography } from "@mui/material";
import { CheckboxStatus } from "@root/utils/enums/checkbox";
import { type ReactNode, useMemo } from "react";
import { useAutocompleteAppellationsContext } from "../context";
import { AutocompleteAppellationsGroup } from "../group";
import { AutocompleteAppellationOption } from "../option";

export const AutocompleteAppellationsPaperSelectedOptions = () => {
  const { selectedOptionsGroups, handleClickSelectedOptionGroup, handleClickSelectedOption } =
    useAutocompleteAppellationsContext();

  const renderedGroups = useMemo(() => {
    const renderedGroups: ReactNode[] = [];
    const selectOptionsGroupsKeys = Object.keys(selectedOptionsGroups);
    for (let i = 0; i < selectOptionsGroupsKeys.length; i++) {
      const group = selectOptionsGroupsKeys[i];
      let groupStatus = CheckboxStatus.NONE;
      const selectedOptions = selectedOptionsGroups[group].options;
      const renderedOptions: ReactNode[] = [];
      for (const selectedOption of selectedOptions) {
        groupStatus |= selectedOption.selected ? CheckboxStatus.CHECKED : CheckboxStatus.UNCHECKED;
        renderedOptions.push(
          <AutocompleteAppellationOption
            key={selectedOption._id}
            label={selectedOption.libelle}
            selected={selectedOption.selected}
            onClick={(event) => handleClickSelectedOption(event, selectedOption)}
          />
        );
      }
      renderedGroups.push(
        <AutocompleteAppellationsGroup
          key={group}
          label={selectedOptions[0].romeLabel}
          status={groupStatus}
          enableCollapse
          noDivider={i >= selectOptionsGroupsKeys.length - 1}
          onClick={(event) => handleClickSelectedOptionGroup(event, group, groupStatus)}
        >
          {renderedOptions}
        </AutocompleteAppellationsGroup>
      );
    }
    return renderedGroups;
  }, [selectedOptionsGroups, handleClickSelectedOptionGroup, handleClickSelectedOption]);

  if (renderedGroups.length === 0) {
    return null;
  }
  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Typography component="p" variant="subtitle2SemiBold" color="primary" sx={{ pb: 2 }}>
        Déjà sélectionnées
      </Typography>
      {renderedGroups}
    </>
  );
};
